import { css, jsx } from '@emotion/core';
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';

import Error from '@/pages/_error';
import ChartProfile from '@/src/profile/ChartProfile';
import Container from '@/src/shared/components/Container';
import Head from '@/src/shared/components/Head';
import Hero from '@/src/shared/components/Hero';
import Layout from '@/src/shared/components/Layout';
import Section from '@/src/shared/components/Section';
import WebLogImage from '@/src/shared/components/WebLogImage';
import request from '@/utils/axios';

const person = {
  Background: '',
  ChartDescription: '',
  Division: '',
  EmailAddress: '',
  Name: '',
  PageTitle: '',
  PersonId: null,
  Phone: '',
  Picture: '',
  Title: '',
};

/** @typedef {typeof person} IChartProfile */

const style = {
  section: css`
    padding-top: 0px !important;
  `,
};

const Staff = () => {
  const router = useRouter();
  const [profileData, setProfileData] = useState(person);
  const path = '/about/leadership/senior-staff';
  const {
    query: { slug: sitepageid },
  } = router;

  const fetchProfile = async () => {
    const response = await request({
      url: `profile/chartprofile`,
      method: 'GET',
      params: {
        personId: Number(sitepageid),
        chartid: 1,
      },
    });
    const { data } = response;
    setProfileData(data);
  };
  useEffect(() => {
    if (sitepageid) {
      fetchProfile();
    }
  }, [sitepageid]);

  return (
    <Layout>
      <Head title={profileData.Name} />
      <Hero
        title={profileData.PageTitle}
        overrideLast={{
          path,
          name: profileData.Name,
        }}
      />
      <Section css={style.section}>
        <Container>
          <ChartProfile profile={profileData} />
        </Container>
      </Section>
      <WebLogImage title={profileData.Name} path={path} sitePageId={sitepageid} />
    </Layout>
  );
};

export default Staff;
